import { render, staticRenderFns } from "./BillResultRow.vue?vue&type=template&id=2bd45600&scoped=true"
import script from "./BillResultRow.vue?vue&type=script&lang=js"
export * from "./BillResultRow.vue?vue&type=script&lang=js"
import style0 from "./BillResultRow.vue?vue&type=style&index=0&id=2bd45600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd45600",
  null
  
)

export default component.exports